export const validationConstants = {
  SET_DOC_VALIDATION_REQUEST: "SET_DOC_VALIDATION_REQUEST",
  SET_DOC_VALIDATION_SUCCESS: "SET_DOC_VALIDATION_SUCCESS",
  SET_DOC_VALIDATION_FAILURE: "SET_DOC_VALIDATION_FAILURE",
};
